import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import { keyframes } from '@mui/system';
import { PushPin as PushPinIcon, FiberManualRecord as RecordIcon } from '@mui/icons-material';
const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
`;
export function RecordingTimerChip({
  duration,
  onComplete
}) {
  const [timeLeft, setTimeLeft] = useState(duration);
  useEffect(() => {
    if (timeLeft <= 0) {
      onComplete();
      return;
    }
    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft, onComplete]);
  return <Chip icon={<Box sx={{
    display: 'flex',
    alignItems: 'center',
    gap: 0.5
  }}>
          <PushPinIcon sx={{
      fontSize: 80,
      color: '#d32f2f',
      transform: 'rotate(45deg)'
    }} />
          <RecordIcon sx={{
      fontSize: 60,
      color: '#d32f2f',
      animation: `${pulse} 1.5s ease-in-out infinite`
    }} />
        </Box>} label={<Typography sx={{
    fontFamily: 'Roboto, sans-serif',
    fontSize: '130px',
    fontWeight: 700,
    color: '#d32f2f'
  }}>
          0:{timeLeft.toString().padStart(2, '0')}
        </Typography>} sx={{
    position: 'absolute',
    bottom: 16,
    left: 16,
    zIndex: 10,
    bgcolor: 'white',
    border: '4px solid #d32f2f',
    boxShadow: '0 8px 24px rgba(211, 47, 47, 0.4)',
    height: 'auto',
    padding: '20px 30px',
    '& .MuiChip-icon': {
      ml: 2
    },
    '& .MuiChip-label': {
      px: 3
    }
  }} />;
}